import { CoreEventBus } from '@databases/core-event-bus';
import { container, type ContainerOverrideOptions } from '@databases/service-container';

/**
 * Registers the core dependencies that are needed before the rest of the container dependencies.
 *
 * Returns a function to register additional dependencies.
 */
export function registerDependenciesRequiredBeforeBootstrap() {
  /**
   * EventBus is used by the bridge data, which is required before bootstrap.
   */
  container.registerSingleton('EventBus', () => new CoreEventBus());

  return function registerOrOverrideServiceContainerDependencies(
    overrides: ContainerOverrideOptions
  ) {
    container.registerSingleton('FlagsManager', overrides.FlagsManager);
    container.registerSingleton('PluginsManager', overrides.PluginsManager);
    container.registerSingleton('PanelManager', overrides.PanelManager);
    container.registerSingleton('PreviewPanelAFMBridge', overrides.PreviewPanelAFMBridge);

    /**
     * This needs to be a factory so that whenever this is read, the latest locale is referenced.
     */
    container.registerFactory('Intl', overrides.Intl);
  };
}
